import {
  EDITABLE_LIST_CUSTOM,
  EDITABLE_LIST_FIELD,
  EDITABLE_LIST_GROUP,
  EditableListDataGridLayout,
} from 'framework/list';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { FormattedTextField } from 'framework/ui/field';
import {
  CLIENT_PORTAL_TASK_STATUS_LABELS,
  CLIENT_PORTAL_TASK_STATUSES,
  CLIENT_PORTAL_TASK_TYPE_LABELS,
} from 'domain/shared/clientPortal';
import TaskPreviewLinkField from './TaskPreviewLinkField';
import DeadlineDateField from './DeadlineDateField';
import { ClientPortalUser } from '../types';
import AssigneeNameField from './AssigneeNameField';

const ClientTaskList = ({ clients = [] }: { clients?: ClientPortalUser[] }) => {
  return (
    <EditableListDataGridLayout
      getTableCells={() =>
        Promise.resolve([
          {
            type: EDITABLE_LIST_GROUP,
            component: Grid,
            componentProps: {
              container: true,
              alignItems: 'center',
              justifyContent: 'space-between',
            },
            gridCellProps: {
              size: 12,
            },
            children: [
              {
                type: EDITABLE_LIST_CUSTOM,
                isEditor: false,
                component: TaskPreviewLinkField,
                componentProps: {
                  projectId: 'projectId',
                  idSource: 'id',
                  aliasSource: 'alias',
                },
                gridCellProps: {
                  size: 0.5,
                  sx: { '.MuiFormControl-root': { mb: 0 }, display: 'flex', justifyContent: 'flex-start' },
                },
              },
              {
                type: EDITABLE_LIST_FIELD,
                source: 'title',
                isEditor: false,
                component: FormattedTextField,
                componentProps: {
                  label: '',
                  format: (str: string) =>
                    str && str.length > 60 ? (
                      <Tooltip title={str}>
                        <div>
                          <Typography
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              lineHeight: 1.2,
                              wordBreak: 'break-word',
                            }}
                          >
                            {str}
                          </Typography>
                        </div>
                      </Tooltip>
                    ) : (
                      str
                    ),
                },
                gridCellProps: {
                  size: 2.5,
                },
              },
              {
                type: EDITABLE_LIST_FIELD,
                source: 'type',
                isEditor: false,
                component: FormattedTextField,
                componentProps: {
                  label: '',
                  format: (str: string) => (
                    <Tooltip title={'Type'} placement={'left'}>
                      <Box>{CLIENT_PORTAL_TASK_TYPE_LABELS[str]}</Box>
                    </Tooltip>
                  ),
                },
                gridCellProps: {
                  size: 3,
                },
              },
              {
                type: EDITABLE_LIST_FIELD,
                source: 'assigneeExternalUserId',
                isEditor: false,
                component: AssigneeNameField,
                componentProps: {
                  clients,
                  isTooltipVisible: true,
                },
                gridCellProps: {
                  size: 2.5,
                },
              },
              {
                type: EDITABLE_LIST_FIELD,
                source: 'status',
                isEditor: false,
                component: FormattedTextField,
                componentProps: {
                  label: '',
                  color: 'error.main',
                  format: (value: string) => (
                    <Tooltip title={'Status'} placement={'left'}>
                      <Typography
                        color={
                          value === CLIENT_PORTAL_TASK_STATUSES.COMPLETED
                            ? 'success'
                            : value === CLIENT_PORTAL_TASK_STATUSES.CANCEL
                              ? 'error'
                              : 'textSecondary'
                        }
                      >
                        {CLIENT_PORTAL_TASK_STATUS_LABELS[value]}
                      </Typography>
                    </Tooltip>
                  ),
                },
                gridCellProps: {
                  size: 2,
                },
              },
              {
                type: EDITABLE_LIST_CUSTOM,
                isEditor: false,
                component: DeadlineDateField,
                gridCellProps: {
                  size: 1,
                  display: 'flex',
                  justifyContent: 'flex-end',
                },
              },
            ],
          },
        ])
      }
    />
  );
};
export default ClientTaskList;
